export default "__VITE_ASSET__CATetz$8__"